var exports = {
  "kL": "SettingsTabLayout.module__container___SjJNNU",
  "Qs": "SettingsTabLayout.module__content___SjJNNU",
  "mK": "SettingsTabLayout.module__subsection___SjJNNU",
};

module.exports = exports;
